import { Component, Element, Event, EventEmitter, h, Host, Prop, Watch } from "@stencil/core";

import { StzhAnchornavItem, StzhAnchornavItemClickEvent } from "../../index";

import { StzhAnchornavLocalizedText } from "./stzh-anchornav.localization";

/**
 *
 */
@Component({
  tag: "stzh-anchornav",
  styleUrl: "stzh-anchornav.scss",
  scoped: true,
})
export class StzhAnchornav {
  /** Translation strings */
  @Prop() localization: StzhAnchornavLocalizedText;

  /**
   * Initial selected values.
   * Array of objects with `label`, `href` and `icon` attribute:
   * `[{"href":"#lorem", "label": "Label 1"}, {"href":"#lorem2", "label": "Label 2"}]`
   */
  @Prop() items: StzhAnchornavItem[] | string = [];
  private _items: StzhAnchornavItem[];

  @Element() element: HTMLStzhAnchornavElement;

  @Watch("items")
  itemsWatcher(newValue: StzhAnchornavItem[] | string) {
    if (typeof newValue === "string") {
      this._items = JSON.parse(newValue);
    } else {
      this._items = newValue;
    }
  }

  /** Item click event */
  @Event() stzhItemClick: EventEmitter<StzhAnchornavItemClickEvent>;

  private handleClick(item: StzhAnchornavItem, originalEvent: MouseEvent) {
    originalEvent.preventDefault(); // Prevent default anchor behavior

    const targetElement = document.querySelector(item.href);
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      // Update the URL with the anchor
      history.pushState(null, "", item.href);
    }

    this.stzhItemClick.emit({
      component: "stzh-anchornav",
      item,
      originalEvent,
    });
  }

  async componentWillLoad() {
    this.itemsWatcher(this.items);
    document.documentElement.style.setProperty("--stzh-anchornav-is-visible", "1");

    if (!this.localization) {
      this.localization = await window.stzhComponents.utils.fetchTranslations(this.element, "anchornav");
    }
  }

  render() {
    const classes = {
      "stzh-anchornav": true,
    };

    return (
      <Host>
        <nav class={classes} role="navigation" aria-label={this.localization.title}>
          <div class="stzh-anchornav__list" role="list">
            {this._items.map(item => (
              <a class="stzh-anchornav__item" role="listitem" href={item.href} onClick={e => this.handleClick(item, e)}>
                <stzh-clamp lines={2} class="stzh-anchornav__label">
                  <div innerHTML={item.label}></div>
                </stzh-clamp>
                <stzh-icon class="stzh-anchornav__icon" name={item.icon || "arrow-down"}></stzh-icon>
              </a>
            ))}
          </div>
        </nav>
      </Host>
    );
  }
}
